import notify from '../../api/notification'
import batchService from '../../api/batch'
import collectionPointService from '../../api/collectionPoint'
import {
  COLLECTION_POINT_UPDATE_LIST,
  COLLECTION_POINT_SERVICE_STATUS,
  COLLECTION_POINT_LOADING_STATUS,
  COLLECTION_POINT_BATCHES
} from '../types'

const state = {
  collectionPoints: [],
  isLoading: false,
  collectionPointServiceStatus: 'STATUS_INITIAL',
  collectionPointBatches: null
}

const mutations = {
  [COLLECTION_POINT_UPDATE_LIST](state, data) {
    state.collectionPoints = data
  },
  [COLLECTION_POINT_SERVICE_STATUS](state, status) {
    state.collectionPointServiceStatus = status
  },
  [COLLECTION_POINT_LOADING_STATUS](state, status) {
    state.isLoading = status
  },
  [COLLECTION_POINT_BATCHES](state, collectionPointBatches) {
    state.collectionPointBatches = collectionPointBatches
  }
}

const getters = {
  collectionPointBatchesHasOpen: state => {
    for (let i in state.collectionPointBatches) {
      if (state.collectionPointBatches[i].state === 'OPENNED') return true
    }
    return false
  },
  collectionPointBatchesLoading: state => {
    if (state.collectionPointServiceStatus === 'SEARCH_BATCHES_STARTED') return true
    return false
  },
  collectionPointLabels: state => {
    let collectionPoints = state.collectionPoints
    collectionPoints.map(obj => {
      obj.value = obj.name
      obj.label = obj.name
      return obj
    })
    return collectionPoints
  },
  collectionPoints: state => {
    return state.collectionPoints
  },
  collectionPointServiceStatus: state => {
    return state.collectionPointServiceStatus
  },
  collectionPointCreateSuccess: state => {
    if (state.collectionPointServiceStatus === 'CREATE_SUCCESS') return true
    return false
  },
  collectionPointCreateError: state => {
    if (state.collectionPointServiceStatus === 'CREATE_INTEGRITY_ERROR') return true
    return false
  },
  collectionPointIsLoading: state => {
    return state.isLoading
  }
}

const actions = {
  collectionPointClearBatches: ({ commit }) => {
    commit(COLLECTION_POINT_BATCHES, null)
  },
  getcollectionPointBatches: ({ commit }, collectionPointName) => {
    commit(COLLECTION_POINT_SERVICE_STATUS, 'SEARCH_BATCHES_STARTED')
    return batchService.getBatchesByCollectionPoint(collectionPointName).then(res => {
      if (res.status === 200) {
        if (res.data.printed || res.data.unprinted) {
          const printed = res.data.printed
          const unprinted = res.data.unprinted
          const collectionPointBatches = printed.concat(unprinted)
          commit(COLLECTION_POINT_BATCHES, collectionPointBatches)
        }
        commit(COLLECTION_POINT_SERVICE_STATUS, 'STATUS_INITIAL')
      }
    })
  },
  setcollectionPointStatus: ({ commit }, status) => {
    commit(COLLECTION_POINT_SERVICE_STATUS, status)
  },
  collectionPointDelete: ({ commit, dispatch }, id) => {
    commit(COLLECTION_POINT_SERVICE_STATUS, 'DELETE_STARTED')
    return collectionPointService
      .deleteCollectionPoint(id)
      .then(res => {
        if (res.status === 200) {
          notify({
            message: 'Posto de coleta excluído com sucesso!',
            style: 'success'
          })
          commit(COLLECTION_POINT_SERVICE_STATUS, 'STATUS_INITIAL')
          dispatch('getAllCollectionPointList')
        }
      })
      .catch(() => {
        commit(COLLECTION_POINT_SERVICE_STATUS, 'DELETE_ERROR')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao deletar posto de coleta.'
        })
      })
  },
  collectionPointCreate: function ({ rootState, commit, dispatch }, name) {
    const laboratory = rootState.authentication.profile.id_laboratory
    commit(COLLECTION_POINT_SERVICE_STATUS, 'CREATE_STARTED')
    return collectionPointService
      .createCollectionPoint({ name: name.trimEnd(), laboratory })
      .then(() => {
        commit(COLLECTION_POINT_SERVICE_STATUS, 'CREATE_SUCCESS')
        dispatch('getAllCollectionPointList')
      })
      .catch(err => {
        if (JSON.stringify(err.response.status)) {
          commit(COLLECTION_POINT_SERVICE_STATUS, 'CREATE_INTEGRITY_ERROR')
        } else {
          commit(COLLECTION_POINT_SERVICE_STATUS, 'STATUS_INITIAL')
          notify({
            title: 'AVISO: ',
            message: 'Erro ao cadastrar posto de coleta.'
          })
        }
      })
  },
  collectionPointEdit: function ({ rootState, commit, dispatch }, { idCollectionPoint, name }) {
    const laboratory = rootState.authentication.profile.id_laboratory
    commit(COLLECTION_POINT_SERVICE_STATUS, 'EDIT_STARTED')
    return collectionPointService
      .editCollectionPoint({ idCollectionPoint, name, laboratory })
      .then(() => {
        commit(COLLECTION_POINT_SERVICE_STATUS, 'EDIT_SUCCESS')
        dispatch('getAllCollectionPointList')
        notify({
          message: 'Posto de coleta editado com sucesso!',
          style: 'success'
        })
      })
      .catch(() => {
        commit(COLLECTION_POINT_SERVICE_STATUS, 'STATUS_INITIAL')
        notify({
          message: 'Erro ao editar posto de coleta.'
        })
      })
  },

  collectionPointClearList: ({ commit }) => {
    commit(COLLECTION_POINT_UPDATE_LIST, [])
  },

  getAllCollectionPointList: ({ rootState, commit }) => {
    const laboratory = rootState.authentication.profile.id_laboratory
    commit(COLLECTION_POINT_LOADING_STATUS, true)
    return collectionPointService
      .getCollectionPoints(laboratory)
      .then(res => {
        commit(COLLECTION_POINT_UPDATE_LIST, res.data)
        commit(COLLECTION_POINT_LOADING_STATUS, false)
      })
      .catch(() => {
        notify({
          message: 'Erro ao carregar postos de coleta.'
        })
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
